import { monthlyInstalmentRepository } from '@/forms/api/repository-factory';
import numberToOrdinal from '@/forms/helpers/number-to-ordinal';
import callApi from '@/lib/helpers/call-api';
import store from '@/store';
import {
  SET_MONTHLY_INSTALMENTS,
} from '@/lib/constants/mutations';

export default {
  async getMonthlyInstalment(currentStep, callbacks) {
    const { form } = currentStep;

    const callApiOptions = {
      callbacks,
      form,
      formElement: currentStep,
      apiCall: monthlyInstalmentRepository.getMonthlyInstalment,
    };

    const response = await callApi(callApiOptions);

    if (response) {
      const monthlyInstalmentsOptions = response
        .map(option => ({
          value: option.STATEMENT_DATE,
          label: `The ${numberToOrdinal(option.STATEMENT_DATE)} day of each month`,
        }));
      store.commit(
        SET_MONTHLY_INSTALMENTS,
        {
          monthlyInstalmentsOptions,
        },
      );
      return true;
    }
    return false;
  },
};
